import { Link as RouterLink } from 'react-router';

// material-ui
import { Link } from '@mui/material';

// project imports
import { DASHBOARD_PATH } from 'config';
import Logo from 'ui-component/Logo';

// ==============================|| MAIN LOGO ||============================== //

const LogoSection = () => (
    <Link component={RouterLink} to={DASHBOARD_PATH} aria-label="berry logo" sx={{paddingTop: "15px"}}>
        <Logo />
    </Link>
);

export default LogoSection;
